var _g, _g2, _title;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#edeeef",
    stroke: "#edeeef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "paris")), /*#__PURE__*/React.createElement("g", {
    id: "paris"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 20,
    height: 5,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75,60.751a9.855,9.855,0,0,1,9.982-9.722h.512a9.855,9.855,0,0,1,9.982,9.722V61H53L39.364,42H22.689L10,61H20.75Z",
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.93,
    y1: 56.986,
    x2: 20.978,
    y2: 56.986,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.098,
    y1: 56.986,
    x2: 49.775,
    y2: 57,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.774,
    y1: 56,
    x2: 27.685,
    y2: 42.428,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.808,
    y1: 57,
    x2: 34.215,
    y2: 42.137,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.682 37 23.318 37 26.714 18 35.286 18 38.682 37",
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.966,
    y1: 24.006,
    x2: 35.97,
    y2: 24.006,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.857 18 28.143 18 29.18 5 32.82 5 33.857 18",
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 5,
    x2: 31,
    y2: 2,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 33,
    x2: 30,
    y2: 33,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 29,
    x2: 34,
    y2: 29,
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "36.267 45.381 43 47 40.394 52.564 49 56",
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.181 45.381 19.15 47.673 22.513 53.175 14.107 56.079",
    style: {
      fill: "none",
      stroke: "#edeeef",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrench);
export default __webpack_public_path__ + "static/media/french.f7bf704d1e742519ae2cc9cd50e1f54c.svg";
export { ForwardRef as ReactComponent };